import { render, staticRenderFns } from "./badge.vue?vue&type=template&id=28187296&scoped=true&"
import script from "./badge.vue?vue&type=script&lang=js&"
export * from "./badge.vue?vue&type=script&lang=js&"
import style0 from "./badge.vue?vue&type=style&index=0&id=28187296&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28187296",
  null
  
)

export default component.exports